// extracted by mini-css-extract-plugin
export default {"root":"LoanProgramCard_root__e+sf6","inactive":"LoanProgramCard_inactive__bBX8j"};